import {
  Provider as CXProvider,
  ErrorProvider as CXErrorProvider,
  DisabledProvider as CXDisabledProvider,
  G_THEME as CXProviderTheme,
  useTheme as useCXTheme,
  THEME_PREFIX as CX_THEME_PREFIX
} from '@sanlamcx/react-ui-next-provider';

export const Provider = CXProvider;
export const G_THEME = CXProviderTheme;
export type G_THEME = CXProviderTheme;
export const DisabledProvider = CXDisabledProvider;
export const ErrorProvider = CXErrorProvider;
export const useGetCXTheme = useCXTheme;
export const THEME_PREFIX = CX_THEME_PREFIX;
